import {AlertIcon} from '@primer/octicons-react'
import type {AbortItem} from '../../../types/events'

/**
 * Renders an abort notice in the timeline.
 * AbortItem is a top-level ConversationItem (not a TurnItem) —
 * it appears between turns when a session is aborted.
 */
export function Abort({item}: {item: AbortItem}) {
  return (
    <div className="d-flex flex-items-center gap-2 px-2 py-2 color-fg-attention">
      <AlertIcon size={16} />
      <span>{item.reason || 'Session aborted'}</span>
    </div>
  )
}
